import { RoundingType } from '@shared/transactions-types';

import type { TransactionPredicate } from './types';

export const hasRoundingTransaction: TransactionPredicate = ({ roundingAmount, roundingType }) =>
    Boolean(roundingAmount) &&
    (roundingType === RoundingType.SAVING || roundingType === RoundingType.DONATION);
